/* 🤖 this file was generated by svg-to-ts */
export const PorIconMagnifier: {
    name: 'magnifier';
    data: string;
} = {
    name: 'magnifier',
    data: `<svg viewBox="0 0 25 25" width="24" height="24"><g fill="currentColor" fill-rule="nonzero"><path d="M24.295 20.891L18.405 15A11.339 11.339 0 0 1 15 18.404l5.89 5.89a2.406 2.406 0 1 0 3.405-3.403z"/><path d="M19 9.5C19 4.254 14.746 0 9.5 0S0 4.254 0 9.5 4.254 19 9.5 19A9.5 9.5 0 0 0 19 9.5zm-9.5 7.125A7.133 7.133 0 0 1 2.375 9.5 7.133 7.133 0 0 1 9.5 2.375 7.133 7.133 0 0 1 16.625 9.5c0 3.93-3.196 7.125-7.125 7.125z"/><path d="M4 9h1.428A3.576 3.576 0 0 1 9 5.429V4C6.243 4 4 6.243 4 9z"/></g></svg>`
};
